export default {
  data() {
    return {
      curTheme: {
        'theme-dark': {
          fontColor: '#ddd',
          donutFontColor: '#fff',
          lineColor: '#495364',
          activeColor: '#FFE100',
          green: '#3CC864',
          bgColor: '#232C37',
          red: '#FF4A4A'
        },
        'theme-light': {
          fontColor: '#303b49',
          donutFontColor: '#333',
          lineColor: '#ddd',
          activeColor: '#F5731E',
          green: '#3CC864',
          bgColor: '#E6EBF0',
          red: '#FF4A4A'
        }
      },
      flowList: {
        redUp: {
          bigInflow: '#6A2B32',
          medianInflow: '#882D3A',
          smallInflow: '#BF4045',
          bigOutflow: '#21603A',
          medianOutflow: '#20863E',
          smallOutflow: '#2E9E4F'
        },
        greenUp: {
          bigInflow: '#21603A',
          medianInflow: '#20863E',
          smallInflow: '#2E9E4F',
          bigOutflow: '#6A2B32',
          medianOutflow: '#882D3A',
          smallOutflow: '#BF4045'
        }
      }
    }
  },
  computed: {
    theme() {
      const theme = this.$store.state.settings.theme
      return theme || 'theme-dark'
    }
  }
}
